import { createId, type Recipe, type RecipeInput, type RecipeIngredient, type RecipeStep } from "../../shared/recipes";
import { normalizeRecipeTags } from "../../shared/recipe-tags";

export function emptyIngredient(): RecipeIngredient {
  return { id: createId(), name: "" };
}

export function emptyStep(): RecipeStep {
  return { id: createId(), summary: "", kind: "cook" };
}

export function emptyRecipeInput(): RecipeInput {
  return {
    title: "",
    servings: 4,
    equipment: [],
    ingredients: [],
    steps: [emptyStep()],
    tags: []
  };
}

export function recipeToInput(recipe: Recipe): RecipeInput {
  return {
    title: recipe.title,
    source: recipe.source,
    estimatedMinutes: recipe.estimatedMinutes,
    servings: recipe.servings,
    equipment: [...recipe.equipment],
    ingredients: recipe.ingredients.map((ingredient) => ({ ...ingredient })),
    steps: recipe.steps.map((step) => ({
      ...step,
      ingredientsUsed: step.ingredientsUsed ? [...step.ingredientsUsed] : undefined,
      timers: step.timers?.map((timer) => ({ ...timer }))
    })),
    tags: normalizeRecipeTags(recipe.tags).map((tag) => ({ path: [...tag.path] }))
  };
}

export function splitStep(steps: RecipeStep[], stepId: string): RecipeStep[] {
  return steps.flatMap((step) => {
    if (step.id !== stepId) {
      return [step];
    }
    const second = emptyStep();
    second.kind = step.kind;
    second.details = step.details;
    return [{ ...step, details: undefined }, second];
  });
}
